import React from 'react';
export const SlovHeader = () =>
{
    return(<h1 id = "slov_header">TRGU NEW YEAR 2025</h1>);
} 